<template>
    <v-container fluid class="container-full-bg-gray">
        <div>
        <app-page-card>
            <template #header>
                {{ title }}
            </template>
            <template>
                <app-row>
                    <app-col>
                        <data-table-with-api
                            ref="networkDrivesTable"
                            :headers="networkDrivesHeaders"
                            :url="'get_network_drives/'"
                            :footer-items-per-page-text="registersItemsPerPageText"
                            :search-filters="[]"
                            :loading="loading"
                            :showSelect="false"
                            @open-update-row="openUpdateDialog"
                        >
                            <template slot="search_right" >
                                <div align="right">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="getNetworkDrives" color="primary" icon v-bind="attrs" v-on="on" :loading="loading">
                                                <v-icon>mdi-refresh</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Actualizar</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="openCreateDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Nueva Unidad</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </data-table-with-api>
                    </app-col>
                </app-row>
                
            </template>
        </app-page-card>

        <app-modal-prompt
            v-model="create_update_dialog"
            :confirmBtnText="modal.confirmBtnText"
            @confirm="confirm()"
            @cancel="closeDialog()"
        >
            <template #title>
                {{ modal.title }}
            </template>
            <app-modal-container>
                <v-form ref="networkDrivesDialogForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                label="Ruta de la unidad de red"
                                v-model="path"
                            ></app-text-field>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                label="Letra de la unidad de red"
                                v-model="letter"
                                maxlength="1"
                            ></app-text-field>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                label="Usuario"
                                v-model="user"
                            ></app-text-field>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                :type="show_pass ? 'text' : 'password'"
                                label="Contraseña"
                                prepend-icon="mdi-lock"
                                :append-icon="show_pass ? 'mdi-eye' : 'mdi-eye-off'"
                                v-model="password"
                                @click:append="show_pass = !show_pass"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>
    </div>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import DataTableWithApi from '../components/DataTableWithApi.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppTextField from '@/components/layout/AppTextField.vue';


export default {
    components: {
        AppPageCard,
        DataTableWithApi,
        AppModalPrompt,
        AppModalContainer,
        AppModalRow,
        AppModalCol,
        AppTextField,
        AppRow,
        AppCol,
    },
    data() {
        return {
            loading: false,
            create_update_dialog: false,
            is_update: false,
            title: 'Unidades de Red',
            show_pass: false,
            networkDrivesHeaders: [
                {
                    text: 'Ruta',
                    sortable: false,
                    value: 'path'
                },
                {
                    text: 'Letra',
                    sortable: false,
                    value: 'letter'
                },
                {
                    text: 'Usuario',
                    sortable: false,
                    value: 'user'
                },
            ],
            registersItemsPerPageText: 'Registros por página:',
            modal: {
                title: '',
                confirmBtnText: ''
            }
        }
    },
    computed: {
        ...mapFields('network_drives', [
            'headers', 'network_drives', 'network_drive_id', 'path', 'letter', 'user', 'password',
        ]),
    },
    methods: {
        ...mapActions({
            getNetworkDrives: 'network_drives/getNetworkDrives',
            createNetworkDrive: 'network_drives/createNetworkDrive',
            updateNetworkDrive: 'network_drives/updateNetworkDrive',
        }),
        refresh() {
            this.loading = true;
            this.getNetworkDrives().then(() => {
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        openCreateDialog() {
            this.modal.title = 'Crear Unidad de Red';
            this.modal.confirmBtnText = 'Crear';
            this.is_update = false;
            this.create_update_dialog = true;
        },
        openUpdateDialog(data) {
            this.modal.title = 'Unidad de Red';
            this.modal.confirmBtnText = 'Actualizar';
            this.is_update = true;
            this.network_drive_id = data.id;
            this.path = data.path;
            this.letter = data.letter.replace(':', '');
            if (data.user)
                this.user = data.user;
            if (data.password)
                this.password = data.password;
            this.create_update_dialog = true;
        },
        closeDialog() {
            this.create_update_dialog = false;
            this.is_update = false;
            this.network_drive_id = '';
            this.path = '';
            this.letter = '';
            this.user = '';
            this.password = '';
        },
        create() {
            this.createNetworkDrive().then(() => {
                this.closeDialog();
                this.getNetworkDrives();
                this.getNetworkDrivesTable();
            });
        },
        getNetworkDrivesTable() {
            if (this.$refs.networkDrivesTable) { 
                this.$refs.networkDrivesTable.getItems().then(() => {
                    this.loading = false;
                }).catch(err => {
                    console.error(err)
                });
            }

        },
        update() {
            this.updateNetworkDrive().then(() => {
                this.closeDialog();
                this.getNetworkDrives();
                this.getNetworkDrivesTable();
            });
        },
        confirm() {
            if (this.is_update) {
                this.update();
            } else {
                this.create();
            }
        }
    },
    mounted() {
        this.refresh();
    }
}

</script>

<style scoped>
    .primary-bckground {
        background-color: var(--v-primary-base);
    }
    .primary-border {
        border-color: var(--v-primary-base) !important;
    }
</style>